// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'wizard';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path fill='currentColor' d='M1.031 9a1.938 1.938 0 1 0 3.876 0 1.938 1.938 0 0 0-3.876 0z' />
    <path d='M7.062 9a1.938 1.938 0 1 0 3.876 0 1.938 1.938 0 0 0-3.876 0zm6.031 0a1.938 1.938 0 1 0 3.876 0 1.938 1.938 0 0 0-3.876 0zM4.908 9h2.154m3.876 0h2.154' />
  </g>
);

export const viewBox = '0 0 18 18';
